'use client'
import clsx from 'clsx'
import { useAtomValue } from 'jotai'
import { type ComponentPropsWithRef } from 'react'
import { loadingOverlayAtom } from './providers/atoms-provider'
import { Spinner } from './spinner'
import { Text } from './text'

type FullScreenLoadingOverlayProps = ComponentPropsWithRef<'div'>

const FullScreenLoadingOverlay = (props: FullScreenLoadingOverlayProps) => {
    const { className, ...otherProps } = props
    const { message, visible } = useAtomValue(loadingOverlayAtom)

    return (
        <div
            className={clsx(
                'absolute inset-0 z-100 flex h-full w-full flex-col items-center justify-center gap-8 bg-white transition-opacity dark:bg-neutral-900',
                visible ? 'opacity-100' : 'pointer-events-none opacity-0',
                className,
            )}
            aria-hidden
            {...otherProps}
        >
            <Text type="title3">{message}</Text>
            <Spinner size="xxl" variant="primary" />
        </div>
    )
}

FullScreenLoadingOverlay.displayName = 'FullScreenLoadingOverlay'

export default FullScreenLoadingOverlay
